import React, { useEffect, useState } from "react";
import { Button, Input, Select, Table } from "antd";
import "aos/dist/aos.css";
import "../../MainCSS.css";
import { Option } from "antd/es/mentions";
import axios from "axios";
import { toast } from "react-toastify";
import { GetWorkerMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi';
import { SaveWorkerMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi';
import { UpdateWorkerMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi';
import { DeleteWorkerMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi';

const JobWorkerMaster = () => {

  const userData = sessionStorage.getItem('authToken');
  const userId = sessionStorage.getItem('userId');
  const authHeaders = sessionStorage.getItem('authHeaders');
  const headersObj = JSON.parse(authHeaders).headers;

  
  const userIp = headersObj.userIp
  const deviceSign = headersObj.deviceSign
  const userLong = headersObj.userLong
  const userLat = headersObj.userLat

  const commonHeaders = {
    headers: {
      createdBy: userId,
      updatedBy: userId,
      userIp: userIp,
      userLat: userLat,
      userLong: userLong,
      deviceSign: deviceSign,
    },
  };

const commonHeaders1 = {
  headers: {
    createdBy: userId,
    updatedBy: userId,
  },
}

  const [errors, setErrors] = useState({
    workerName: "",
    address: "",
    city: "",
    pinCode: "",
    gstIn: "",
    contactPerson1: "",
    designation1: "",
    mobileNo1: "",
    contactPerson2: "",
    designation2: "",
    mobileNo2: "",
    natureOfJob: "",
  });


  const [pageSize, setPageSize] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);

  const [workerId, setWorkerId] = useState("");
  const [workerName, setWorkerName] = useState(""); 
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [gstIn, setGstIn] = useState("");
  const [contactPerson1, setContactPerson1] = useState("");
  const [designation1, setDesignation1] = useState("");
  const [mobileNo1, setMobileNo1] = useState("");
  const [contactPerson2, setContactPerson2] = useState("");
  const [designation2, setDesignation2] = useState("");
  const [mobileNo2, setMobileNo2] = useState("");
  const [natureOfJob, setNatureOfJob] = useState("");

  const [allWorker, setAllWorker] = useState([]);
  const [updateButton, setUpdateButton] = useState(false);
  const [saveButton, setSaveButton] = useState(true);


  //======Search data from table===============
  const handleSearch = (value) => {
    const searchValue = value.toLowerCase();
  
    const filtered = allWorker.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? "").toLowerCase().includes(searchValue)
      )
    );
  
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };
  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };


    // Fetch Worker Names
    let isWorkerFetched = false;
    useEffect(() => {
      if (isWorkerFetched) return;
      fetchWorker();
      isWorkerFetched = true;
    }, []);

  // ==============Get Table Data================

  let isError = false;

  const fetchWorker = async () => {
    try {
      const response = await axios.get(GetWorkerMaster,commonHeaders1);
      if (response.data !== null) {
        setAllWorker(response.data);
        setFilteredData(response.data); 
        setTotalEntries(response.data.length);
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Worker:", error);
        toast.error("Failed to fetch Worker data");
        isError = true; 
      }
    }
  };

    // const columns = [
    //   {
    //     title: "Sr.No.",
    //     dataIndex: "",
    //     key: "index",
    //     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    //   },
    //   {
    //     title: "Worker Name",
    //     dataIndex: "name",
    //     key: "name",
    //   },
    //   {
    //     title: "Address",
    //     dataIndex: "address",
    //     key: "address",
    //   },
    //   {
    //     title: "City",
    //     dataIndex: "city",
    //     key: "city",
    //   },
    //   {
    //     title: "Pin Code",
    //     dataIndex: "pinCode",
    //     key: "pinCode",
    //   },
    //   {
    //     title: "GSTIN",
    //     dataIndex: "gstin",
    //     key: "gstin",
    //   },
    //   {
    //     title: "Contact Person1",
    //     dataIndex: "contactPerson1",
    //     key: "contactPerson1",
    //   },
    //   {
    //     title: "Designation",
    //     dataIndex: "designation1",
    //     key: "designation1",
    //   },
    //   {
    //     title: "MobileNo",
    //     dataIndex: "mobileNo1",
    //     key: "mobileNo1",
    //   },
    //   {
    //     title: "Contact Person2",
    //     dataIndex: "contactPerson2",
    //     key: "contactPerson2",
    //   },
    //   {
    //     title: "Designation",
    //     dataIndex: "designation2",
    //     key: "designation2",
    //   },
    //   {
    //     title: "MobileNo",
    //     dataIndex: "mobileNo2",
    //     key: "mobileNo2",
    //   },
    //   {
    //     title: "Nature Of Job",
    //     dataIndex: "natureOfJob",
    //     key: "natureOfJob",
    //   },
    //   {
    //     title: "Actions",
    //     key: "actions",
    //     render: (text, record) => (
    //       <div>
    //         <span
    //           type="submit"
    //           style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
    //           onClick={() => handleEditDataButton(record)}
    //         >
    //           <i class="fa-solid fa-pen-to-square"></i>
    //         </span>
    //         <span
    //           type="submit"
    //           style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
    //           onClick={() => handleDeleteData(record)} 
    //         >
    //           <i class="fa-solid fa-trash"></i>
    //         </span>
    //       </div>
    //     ),
    //   },
    // ];

    const columns = [
  {
    title: "Sr.No.",
    dataIndex: "",
    key: "index",
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Worker Name",
    dataIndex: "name",
    key: "name",
    sorter: (a, b) => a.name.localeCompare(b.name), // Sorting alphabetically for Worker Name
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
    sorter: (a, b) => a.address.localeCompare(b.address), // Sorting alphabetically for Address
  },
  {
    title: "City",
    dataIndex: "city",
    key: "city",
    sorter: (a, b) => a.city.localeCompare(b.city), // Sorting alphabetically for City
  },
  {
    title: "Pin Code",
    dataIndex: "pinCode",
    key: "pinCode",
    sorter: (a, b) => a.pinCode - b.pinCode, // Sorting numerically for Pin Code
  },
  {
    title: "GSTIN",
    dataIndex: "gstin",
    key: "gstin",
    sorter: (a, b) => a.gstin.localeCompare(b.gstin), // Sorting alphabetically for GSTIN
  },
  {
    title: "Contact Person1",
    dataIndex: "contactPerson1",
    key: "contactPerson1",
    sorter: (a, b) => a.contactPerson1.localeCompare(b.contactPerson1), // Sorting alphabetically for Contact Person1
  },
  {
    title: "Designation",
    dataIndex: "designation1",
    key: "designation1",
    sorter: (a, b) => a.designation1.localeCompare(b.designation1), // Sorting alphabetically for Designation1
  },
  {
    title: "MobileNo",
    dataIndex: "mobileNo1",
    key: "mobileNo1",
    sorter: (a, b) => a.mobileNo1 - b.mobileNo1, // Sorting numerically for MobileNo1
  },
  {
    title: "Contact Person2",
    dataIndex: "contactPerson2",
    key: "contactPerson2",
    sorter: (a, b) => a.contactPerson2.localeCompare(b.contactPerson2), // Sorting alphabetically for Contact Person2
  },
  {
    title: "Designation",
    dataIndex: "designation2",
    key: "designation2",
    sorter: (a, b) => a.designation2.localeCompare(b.designation2), // Sorting alphabetically for Designation2
  },
  {
    title: "MobileNo",
    dataIndex: "mobileNo2",
    key: "mobileNo2",
    sorter: (a, b) => a.mobileNo2 - b.mobileNo2, // Sorting numerically for MobileNo2
  },
  {
    title: "Nature Of Job",
    dataIndex: "natureOfJob",
    key: "natureOfJob",
    sorter: (a, b) => a.natureOfJob.localeCompare(b.natureOfJob), // Sorting alphabetically for Nature Of Job
  },
  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <div>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
          onClick={() => handleEditDataButton(record)}
        >
          <i class="fa-solid fa-pen-to-square"></i>
        </span>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
          onClick={() => handleDeleteData(record)} 
        >
          <i class="fa-solid fa-trash"></i>
        </span>
      </div>
    ),
  },
      ];


  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#023E7D",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };


 //=========CANCEL WORKER DATA============
const handleCancel = () => {
  setWorkerName("");
  setAddress("");
  setCity("");
  setPinCode("");
  setGstIn("");
  setContactPerson1("");
  setDesignation1("");
  setMobileNo1("");
  setContactPerson2("");
  setDesignation2("");
  setMobileNo2("");
  setNatureOfJob("");

  setUpdateButton(false);
  setSaveButton(true);
  setErrors("");
};

 //=========SAVE WORKER DATA============
    const handleSubmit = async () => {
        let isValid = true;
        const errorObj = {};  
    
        if (!workerName.trim()) {
          isValid = false;
          errorObj.workerName = "Worker Name is required *";
        }
        if (!address) {
          isValid = false;
          errorObj.address = "Address is required *";
        }
        if (!city) {
          isValid = false;
          errorObj.city = "City is required *";
        }
        if (!pinCode) {
          isValid = false;
          errorObj.pinCode = "Pin Code is required *";
        }
        if (!gstIn) {
          isValid = false;
          errorObj.gstIn = "GSTIN is required *";
        }
        if (!contactPerson1.trim()) {
          isValid = false;
          errorObj.contactPerson1 = "Contact Person is required *";
        }
        if (!designation1.trim()) {
          isValid = false;
          errorObj.designation1 = "Designation is required *";
        }
        if (!mobileNo1.trim()) {
          isValid = false;
          errorObj.mobileNo1 = "Mobile No. is required *";
        }
        if (!contactPerson2.trim()) {
          isValid = false;
          errorObj.contactPerson2 = "Contact Person is required *";
        }
        if (!designation2.trim()) {
          isValid = false;
          errorObj.designation2 = "Designation is required *";
        }
        if (!mobileNo2.trim()) {
          isValid = false;
          errorObj.mobileNo2 = "Mobile No. is required *";
        }       
        if (!natureOfJob.trim()) {
          isValid = false;
          errorObj.natureOfJob = "Nature of Job is required *";
        }
       
    
        setErrors(errorObj); // Set error messages
    
        if (!isValid) return;
    
        const saveData = {
            name: workerName,
            address: address,
            city: city,
            pinCode: parseFloat(pinCode),
            gstin: gstIn,
            contactPerson1: contactPerson1,
            designation1: designation1,
            mobileNo1: parseFloat(mobileNo1),
            contactPerson2: contactPerson2,
            designation2: designation2,
            mobileNo2: parseFloat(mobileNo2),
            natureOfJob: natureOfJob,
          };       
        
    
        try {
          const response = await axios.post(SaveWorkerMaster, saveData,commonHeaders);
    
          if (response.data === "CREATED") {
            toast.success("Added successfully!");
            fetchWorker();
            handleCancel();
          }
          else if (response.data === "ALREADYEXISTED") {
            toast.warn("Already exist!");
          }
        } catch (error) {
          console.error("Error during API call:", error);
          toast.error("Error occurred while submitting data");
        }
    };

//=========EDIT WORKER DATA============
const handleEditDataButton = (item) => {
  setUpdateButton(true);
  setSaveButton(false);

  setWorkerId(item.id);
  setWorkerName(item.name);
  setAddress(item.address);
  setCity(item.city);
  setPinCode(item.pinCode);
  setGstIn(item.gstin);
  setContactPerson1(item.contactPerson1);
  setDesignation1(item.designation1);
  setMobileNo1(item.mobileNo1);
  setContactPerson2(item.contactPerson2);
  setDesignation2(item.designation2);
  setMobileNo2(item.mobileNo2);
  setNatureOfJob(item.natureOfJob);
};

 //=========UPDATE WORKER DATA============
const handleUpdate = async () => {
  if (
    !workerName || !address ||  !city || !pinCode || !address || !gstIn || !contactPerson1 || !designation1 || !mobileNo1 || !contactPerson2 || !designation2 || !mobileNo2 || !natureOfJob ) {
    toast.warn("Please fill all fields!");
    return;
  }

  const updateData = {
    id: workerId,
    name: workerName,
    address: address,
    city: city,
    pinCode: parseFloat(pinCode),
    gstin: gstIn,
    contactPerson1: contactPerson1,
    designation1: designation1,
    mobileNo1: parseFloat(mobileNo1),
    contactPerson2: contactPerson2,
    designation2: designation2,
    mobileNo2: parseFloat(mobileNo2),
    natureOfJob: natureOfJob,
  };


  try {
    const response = await axios.put(UpdateWorkerMaster, updateData,commonHeaders);

    if (response.data === "UPDATED") {
      toast.success("Updated successfully!");
      fetchWorker();
      handleCancel();
    }
    else if (response.data === "ALREADYEXISTED") {
      toast.warn("Already exist!");
    }
  } catch (error) {
    console.error("Error during API call:", error);
    toast.error("Error occurred while updating data");
  }
};

 //=========DELETE WORKER DATA============
const handleDeleteData = async (item) => {
  const confirmDelete = window.confirm(
    `Are you sure you want to delete the Worker "${item.name}"?`
  );
  if (!confirmDelete) return;

  try {
    const response = await axios.delete(`${DeleteWorkerMaster}?id=${item.id}`,commonHeaders1);
    if (response.data === "DELETED") {
      toast.success("Deleted successfully!");
      fetchWorker();
      handleCancel();
    }
  } catch (error) {
    console.error("Error during delete operation:", error);
    toast.error("Error occurred while deleting the Job Worker");
  }
};

  return (
    <>
      <div className="px-5 py-3">
        <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          <div className="col-12">

            <div className="row px-md-5 mt-3 p-2" >
                  <div className="col-md-1"></div>
                  <div className="col-md-10">
                      <div className="row p-0 m-0">

                        <div className="col-lg-8 py-1">
                              <label className="labels">Name</label>
                              <Input maxLength={250}
                                value={workerName}
                                onChange={(e) => setWorkerName(e.target.value)}
                                placeholder="Enter Name"
                              />
                              {errors.workerName && (
                                <div className="errorField">{errors.workerName}</div>
                              )}
                        </div>

                        <div className="col-lg-4 py-1">
                              <label className="labels">GSTIN</label>
                              <Input
                                value={gstIn} maxLength={250}
                                onChange={(e) => setGstIn(e.target.value)}
                                placeholder="Enter Code"
                              />
                              {errors.gstIn && (
                                <div className="errorField">{errors.gstIn}</div>
                              )}
                        </div>

                        <div className="col-lg-10 py-1">
                            <label className="labels">Address</label>
                            <Input.TextArea
                              value={address}
                              onChange={(e) => setAddress(e.target.value)}
                              placeholder="Enter Address"
                              maxLength={250}
                            />
                            {errors.address && <div className="errorField">{errors.address}</div>}
                        </div> 
                        <div className="col-lg-2"></div>

                        <div className="col-lg-5 py-1">
                              <label className="labels">City</label>
                              <Input
                                value={city} maxLength={250}
                                onChange={(e) => setCity(e.target.value)}
                                placeholder="Enter Name"
                              />
                              {errors.city && (
                                <div className="errorField">{errors.city}</div>
                              )}
                        </div>

                        <div className="col-lg-3 py-1">
                              <label className="labels">Pin Code</label>
                              <Input
                                value={pinCode} maxLength={6}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,10}$/.test(value)) setPinCode(value); // only allow up to 10 digits
                                  }}
                                placeholder="Enter Code"
                              />
                              {errors.pinCode && (
                                <div className="errorField">{errors.pinCode}</div>
                              )}
                        </div>
                        <div className="col-lg-4"></div>

                      <div className="col-lg-5 py-1">
                              <label className="labels">Contact Person 1</label>
                              <Input
                                value={contactPerson1} maxLength={250}
                                onChange={(e) => setContactPerson1(e.target.value)}
                                placeholder="Enter Code"
                              />
                              {errors.contactPerson1 && (
                                <div className="errorField">{errors.contactPerson1}</div>
                              )}
                        </div>

                        <div className="col-lg-4 py-1">
                              <label className="labels">Designation 1</label>
                              <Input
                                value={designation1} maxLength={250}
                                onChange={(e) => setDesignation1(e.target.value)}
                                placeholder="Enter Code"
                              />
                              {errors.designation1 && (
                                <div className="errorField">{errors.designation1}</div>
                              )}
                        </div>

                        <div className="col-lg-3 py-1">
                              <label className="labels">Mobile No.1</label>
                              <Input
                                  value={mobileNo1}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,10}$/.test(value)) setMobileNo1(value); // only allow up to 10 digits
                                  }}
                                  placeholder="Enter Mobile Number"
                                  maxLength={10}
                                />
                                {errors.mobileNo1 && (
                                  <div className="errorField">{errors.mobileNo1}</div>
                                )}
                        </div>

                        <div className="col-lg-5 py-1">
                              <label className="labels">Contact Person 2</label>
                              <Input
                                value={contactPerson2} maxLength={250}
                                onChange={(e) => setContactPerson2(e.target.value)}
                                placeholder="Enter Code"
                              />
                              {errors.contactPerson2 && (
                                <div className="errorField">{errors.contactPerson2}</div>
                              )}
                        </div>

                        <div className="col-lg-4 py-1">
                              <label className="labels">Designation 2</label>
                              <Input
                                value={designation2} maxLength={250}
                                onChange={(e) => setDesignation2(e.target.value)}
                                placeholder="Enter Code"
                              />
                              {errors.designation2 && (
                                <div className="errorField">{errors.designation2}</div>
                              )}
                        </div>

                        <div className="col-lg-3 py-1">
                              <label className="labels">Mobile No.2</label>
                              <Input
                                  value={mobileNo2}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,10}$/.test(value)) setMobileNo2(value); // only allow up to 10 digits
                                  }}
                                  placeholder="Enter Mobile Number"
                                  maxLength={10}
                                />
                                {errors.mobileNo2 && (
                                  <div className="errorField">{errors.mobileNo2}</div>
                                )}
                        </div>

                        <div className="col-lg-5 py-1">
                              <label className="labels">Nature Of Job</label>
                              <Input
                                value={natureOfJob} maxLength={250}
                                onChange={(e) => setNatureOfJob(e.target.value)}
                                placeholder="Enter Nature"
                              />
                              {errors.natureOfJob && (
                                <div className="errorField">{errors.natureOfJob}</div>
                              )}
                        </div>                             

                      </div> 
                  </div> 
                  <div className="col-md-1"></div>

                    <div className="col-12 text-center pt-3">
                      <Button
                        type="submit"
                        className="CancelBtn mx-1"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                      {saveButton && (
                      <Button
                        type="submit"
                        className="SubmitBtn mx-1"
                        onClick={handleSubmit}
                      >
                        Submit
                      </Button>
                      )}
                      {updateButton && (
                        <Button
                          type="submit"
                          className="UpdateBtn mx-1"
                          onClick={handleUpdate}
                        >
                          Update
                        </Button>
                      )}
                    </div>

              <div  className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid rgb(207, 207, 207)" }}></div>
            </div>

            {/*================ Table =========================*/}
            <div className="row m-0 p-2 px-md-5 pt-md-0 mt-3">
              <div
                className="col-12 py-3 shadow border"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="col-12 px-md-5"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                    <Select
                      defaultValue={pageSize}
                      onChange={handlePageSizeChange}
                      style={{ width: 120, textAlign: "center" }}
                    >
                      <Option value={10}>10</Option>
                      <Option value={20}>20</Option>
                      <Option value={30}>30</Option>
                    </Select>
                  </div>

                  <div className="pt-4 pt-md-0">
                    <Input.Search
                      placeholder="Search"
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{ width: 200, marginBottom: 16 }}
                    />
                  </div>
                </div>

                <div style={{ backgroundColor: "white" }}>
                  <Table
                    bordered
                    style={{ padding: "0px 20px", overflowX: "auto" }}
                    columns={columns}
                    dataSource={filteredData}
                    pagination={{
                      pageSize: pageSize,
                      total: totalEntries,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      current: currentPage,
                      onChange: (page) => setCurrentPage(page),
                    }}
                    showSorterTooltip={false}
                    rowKey={(record) => record.id}
                    components={components}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
   </>
  )
}

export default JobWorkerMaster